import { environment } from 'src/environments/environment';

// All values come from src/environments/environment*.ts (replaced at build time per environment)
const buildUrl = (ip: string, port: string): string => port ? ip.concat(":", port) : ip;

export const ip: string = environment.api.ip;
export const port: string = environment.api.port;
export const urlServer: string = buildUrl(ip, port);

export const msSectorIp: string = environment.ms.sector.ip;
export const msPort: string = environment.ms.sector.port;
export const msUrlServer: string = buildUrl(msSectorIp, msPort);

export const msIp: string = environment.ms.survey.ip;
export const msSurveyPort: string = environment.ms.survey.port;
export const msSurveyUrlServer: string = buildUrl(msIp, msSurveyPort);

export const msLeavePort: string = environment.ms.leave.port;
export const msLeaveUrlServer: string = buildUrl(environment.ms.leave.ip, msLeavePort);

export const msHelpPort: string = environment.ms.help.port;
export const msHelpUrlServer: string = buildUrl(environment.ms.help.ip, msHelpPort);

export const msMessagePort: string = environment.ms.message.port;
export const msMessageUrlServer: string = buildUrl(environment.ms.message.ip, msMessagePort);

export const frontUrl: string = environment.frontUrl;
export const jiraBrowseUrl: string = environment.links.jiraBrowseUrl;
export const companyUrl: string = environment.links.companyUrl;
export const masterfieldUrl: string = environment.links.masterfieldUrl;
